import { CSSProperties, ReactNode } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
  header: ReactNode;
  body: ReactNode;
  confirmLabel?: string | null;
  cancelLabel?: string | null;
  style?: CSSProperties;
}

export const ConfirmationModal = ({
  isOpen,
  toggle,
  onConfirm,
  onCancel,
  header,
  body,
  confirmLabel = "OK",
  cancelLabel = "Close",
  style,
}: Props) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} style={style}>
      <ModalHeader toggle={toggle}>{header}</ModalHeader>
      <ModalBody>{body}</ModalBody>
      <ModalFooter>
        {cancelLabel && (
          <Button
            color="light"
            onClick={() => {
              onCancel?.();
              toggle();
            }}
          >
            {cancelLabel}
          </Button>
        )}
        <div className="flex-grow-1" />
        {confirmLabel && (
          <Button
            color="dark"
            onClick={() => {
              onConfirm?.();
              toggle();
            }}
          >
            {confirmLabel}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};
